/**
 * apps/web :: pass :: screens/OnTripChecklist
 *
 * Phase-2 checklist — what to keep in mind while you're driving
 * (ROADS-569 W1.C4). Thin wrapper over ChecklistScreen with phase="on".
 */
import ChecklistScreen from "./ChecklistScreen";

export default function OnTripChecklist(): JSX.Element {
  return (
    <ChecklistScreen
      phase="on"
      eyebrow="Phase 2 · While you're driving"
      title="On-trip checklist"
      accent="text-indigo-600"
    />
  );
}
